/**
 * Device Info Utility — MangoTV
 * Detects browser/device info for login V2 payload.
 * Pattern: mirrors glotv deviceInfo.js
 */

/**
 * Generate a persistent device fingerprint ID
 */
const getDeviceId = () => {
  let deviceId = localStorage.getItem("mango_device_id");
  if (!deviceId) {
    deviceId =
      "mango_" +
      Date.now().toString(36) +
      "_" +
      Math.random().toString(36).substr(2, 9);
    localStorage.setItem("mango_device_id", deviceId);
  }
  return deviceId;
};

/**
 * Detect device class from user agent
 * @returns {"MOBILE"|"TABLET"|"DESKTOP"}
 */
const getDeviceClass = () => {
  const ua = navigator.userAgent;
  if (/Mobi|Android.*Mobile|iPhone|iPod/i.test(ua)) return "MOBILE";
  if (/Tablet|iPad|Android(?!.*Mobile)/i.test(ua)) return "TABLET";
  return "DESKTOP";
};

/**
 * Detect operating system
 * @returns {"ANDROID"|"IOS"|"WINDOWS"|"MACOS"|"LINUX"|"UNKNOWN"}
 */
const getDeviceOS = () => {
  const ua = navigator.userAgent;
  if (/Android/i.test(ua)) return "ANDROID";
  if (/iPhone|iPad|iPod/i.test(ua)) return "IOS";
  if (/Windows/i.test(ua)) return "WINDOWS";
  if (/Mac/i.test(ua)) return "MACOS";
  if (/Linux/i.test(ua)) return "LINUX";
  return "UNKNOWN";
};

/**
 * Get device type (browser/model string)
 */
const getDeviceType = () => {
  const ua = navigator.userAgent;
  // Try to extract browser name + version
  const browserMatch = ua.match(
    /(Chrome|Firefox|Safari|Edge|Opera|OPR|MSIE|Trident)[\s/]?([\d.]+)?/
  );
  if (browserMatch) {
    const name = browserMatch[1] === "OPR" ? "Opera" : browserMatch[1];
    return `${name} ${browserMatch[2] || ""}`.trim();
  }
  return "Web Browser";
};

/**
 * Get comprehensive device information for login V2
 * @returns {Object} Device info payload
 */
export const getDeviceInfo = () => {
  return {
    device: getDeviceId(),
    device_class: getDeviceClass(),
    device_type: getDeviceType(),
    device_os: getDeviceOS(),
    device_mac_1: getDeviceId(), // Use device ID as MAC substitute for web
    device_metadata: {
      user_agent: navigator.userAgent,
      language: navigator.language,
      platform: navigator.platform,
      screen: `${window.screen.width}x${window.screen.height}`,
      app: "MangoTV Web",
      app_version: "1.0.0",
    },
  };
};
